import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext"; 
import NavBar from "./components/NavBar";
import { Toaster } from "sonner"; // 🔥 THIS IS REQUIRED FOR TOASTS TO SHOW 🔥
// Pages
import RrgPage from "./pages/RrgPage";
import UploadPage from "./pages/UploadPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import IndicatorsPage from "./pages/IndicatorsPage"; 
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/rrg" replace />;
  return children;
};
const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/rrg" replace />;
  return children;
};
export default function App() {
  return (
    <AuthProvider>
      <Router>
        {/* 🔥 Add Toaster here so it works across all pages 🔥 */}
        <Toaster position="top-right" richColors />
        <NavBar /> 
        
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
          
          <Route path="/" element={<Navigate to="/rrg" replace />} />
          <Route path="/rrg" element={<RrgPage />} />
          <Route path="/indicators" element={<ProtectedRoute><IndicatorsPage /></ProtectedRoute>} />
          <Route path="/upload" element={<AdminRoute><UploadPage /></AdminRoute>} />
          
          <Route path="*" element={<Navigate to="/rrg" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}